<template>
  <div>
    <v-card class="pa-2 ma-2">
      <v-card-title class="headline">Тезисы
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="get_thesis_doc()">скачать в *.doc</v-btn>
      </v-card-title>

        <v-row>
              <v-card-text style="text-align: center; font-size: 16px;">
                <b>{{ thesis.name }}</b>
              </v-card-text>
              <v-card-text style="text-align: center; font-size: 16px;">
                <u><b>{{ thesis.author.fio }}</b></u><sup><b> {{ (thesis.author.org_id + 1).toString() }}</b></sup>
                <b v-for="co in thesis.coautors">, {{ co.fio }}<sup><b>{{ (co.org_id + 1).toString() }}</b></sup></b>
              </v-card-text>
              <v-card-text class="pa-0" v-for="org, id in author_orgs" style="text-align: center; font-size: 14px;" :key="id">
                <p style="font-style: italic;"><sup>{{ (id + 1).toString() }}</sup>{{ org }}<i v-if="id == 0"  style="font-style: italic;">, {{ thesis.email }}</i></p>
              </v-card-text>

              <v-card-text v-html="view_thesis" style="text-indent: 20px; text-align: justify;"></v-card-text>
              <!-- <p>
                {{ view_thesis }}
              </p> -->
              <v-card-text  style="text-indent: 20px; text-align: justify;">
                {{ thesis.finance }}
              </v-card-text>

              <v-card-text style="text-align: center; font-size: 16px;" class="pb-0">
                <b>Литература</b>
              </v-card-text>
              <v-card-text class="pa-0" v-for="lit_descr,id in thesis.lit" :key="id" style="text-indent: 20px; text-align: justify;font-size: 12px;">
                <p v-if="lit_descr.length > 0" class="mb-0">{{ (id+1).toString() }}. {{ lit_descr }}</p>            
              </v-card-text>
           
              <v-card-text>
                <p></p>
              </v-card-text>

        </v-row>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="$emit('closeDialog', -1)">закрыть</v-btn>
      </v-card-actions>

    </v-card>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  mounted() {
    this.update_data()
    // this.uploadDataUser();
  },
  name: 'ThesisShow',

  props: {
    thesis_data: [Array, Object]
  },

  data: () => ({
    loading: false,
    thesis: {
      name: '',
      text: '',
      finance: '',
      email: '',
      lit: '',
      coautors: [],
      author: {
        fio: '', 
        org: '', 
        id: 0,
        org_id: 0
      }
    },
    author_orgs: [],
    orgs_count: 1,
    authors_count: 1,
    view_thesis: '',
  }),

  components: {
  },

  watch: {
    thesis_data(val){
      this.update_data()
    },

    'thesis.text'(val){
      var t = this.thesis.text.replaceAll('<i>','<i style="font-style: italic;">')
      // console.log('thesis.text', t)
      this.view_thesis = '<p style="margin-bottom: 0px">' +  t.replace(/\n/g,'</p><p style="margin-bottom: 0px">') + '</p>'
    },
  },

  computed: {
    ...mapGetters([
    ]),
  },

  created() {
  },

  methods: {
    ...mapActions([
      'UPLOAD_THESIS', 'UPLOAD_THESIS_TO_DOCX'
    ]),
    ...mapMutations([
      'UPDATE_OVERLAY',
    ]),

    update_data(){
      this.thesis = this.thesis_data
      this.recalc_authors()
    },

    get_thesis_doc(){
      this.UPDATE_OVERLAY(true)
      this.UPLOAD_THESIS_TO_DOCX(this.thesis.id)
        .then((res) => {
          this.UPDATE_OVERLAY(false)
        })
        .catch((e) => this.UPDATE_OVERLAY(false));
    },

    recalc_authors(){
      var found = -1
      this.author_orgs = []
      this.author_orgs.push(this.thesis.author.org)
      this.thesis.coautors.forEach((item) => {
        found = -1
        if(item.org.length > 0){
          this.author_orgs.forEach((jtem, count) => {
            if(item.org == jtem)
              found = count
          })
          if(found > -1){
            item.org_id = found
          }
          else{
            this.author_orgs.push(item.org)
            item.org_id = this.author_orgs.length - 1
          }
        }
      })
    },
  }

};
</script>
